import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1 q-mt-none justify-be" }, " Date Range ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, " Media ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, " Social Sites ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, " Posts ", -1)
const _hoisted_5 = { class: "text-subtitle1" }
const _hoisted_6 = { class: "q-mt-md text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectDateRange = _resolveComponent("SelectDateRange")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_MediaFilter = _resolveComponent("MediaFilter")!
  const _component_PostsPlatformToolbar = _resolveComponent("PostsPlatformToolbar")!
  const _component_SelectStatus = _resolveComponent("SelectStatus")!
  const _component_PersonsSidebarBtn = _resolveComponent("PersonsSidebarBtn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_TotalPosts = _resolveComponent("TotalPosts")!
  const _component_AsyncBtn = _resolveComponent("AsyncBtn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    title: _ctx.title
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AsyncBtn, {
        label: "Generate",
        color: "primary",
        task: _ctx.task,
        disable: !_ctx.canGenerate,
        onClick: _ctx.generate
      }, null, 8, ["task", "disable", "onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_SelectDateRange, {
        modelValue: _ctx.dateRange,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event)),
        "date-of-loss": _ctx.client.dateOfLoss
      }, null, 8, ["modelValue", "date-of-loss"]),
      _createVNode(_component_q_separator, { class: "q-mt-md" }),
      _hoisted_2,
      _createVNode(_component_MediaFilter, {
        modelValue: _ctx.mediaTypes,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mediaTypes) = $event)),
        rounded: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_separator, { class: "q-mt-md" }),
      _hoisted_3,
      _createVNode(_component_PostsPlatformToolbar, {
        "category-ids": _ctx.categoryIds,
        "lifecycle-statuses": _ctx.lifecycleStatuses,
        onChange: _ctx.onCategoryIdsChanged,
        onLifecycleChange: _ctx.onLifecycleChange
      }, null, 8, ["category-ids", "lifecycle-statuses", "onChange", "onLifecycleChange"]),
      _createVNode(_component_q_separator, { class: "q-mt-md" }),
      _hoisted_4,
      _createVNode(_component_SelectStatus, {
        filters: _ctx.postFilters,
        "onUpdate:filters": _ctx.selectStatus
      }, null, 8, ["filters", "onUpdate:filters"]),
      _createVNode(_component_q_separator, { class: "q-mt-md" }),
      _createElementVNode("h2", _hoisted_5, [
        _createTextVNode(" Filter by People "),
        _createVNode(_component_PersonsSidebarBtn, {
          "client-id": _ctx.client.id,
          "person-ids": _ctx.personIds,
          "onUpdate:personIds": _cache[2] || (_cache[2] = ($event: any) => (_ctx.personIds = $event))
        }, null, 8, ["client-id", "person-ids"])
      ]),
      _createVNode(_component_q_separator, { class: "q-my-md" }),
      _createVNode(_component_q_input, {
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.name) = $event)),
        label: "Report Name",
        outlined: ""
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TotalPosts, { filters: _ctx.postFilters }, null, 8, ["filters"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}